import React from "react";
import styles from "../../../styles/components/PlanChangePreviewModal.module.css";

const fmtMoneyCents = (cents, currency = "usd") => {
  const amount = Number(cents || 0) / 100;

  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: currency?.toUpperCase() || "USD",
  }).format(amount);
};

const fmtDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleString("es-AR");
};

const PlanChangePreviewModal = ({
  open,
  preview,
  loading,
  onClose,
  onConfirm,
}) => {
  if (!open || !preview) return null;

  return (
    <div className={styles.backdrop}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div>
            <div className={styles.eyebrow}>Cambio de plan</div>
            <h3 className={styles.title}>Confirmar cambio de plan</h3>
          </div>

          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <div className={styles.summaryCard}>
          <div className={styles.summaryText}>
            Vas a cambiar de <strong>{preview.current_plan_name}</strong> a{" "}
            <strong>{preview.new_plan_name}</strong>.
          </div>
        </div>

        <div className={styles.amountGrid}>
          <div className={styles.amountCard}>
            <span className={styles.amountLabel}>Se cobrará ahora</span>
            <strong className={styles.amountValue}>
              {fmtMoneyCents(preview.total_due_now_cents, preview.currency)}
            </strong>
          </div>

          <div className={styles.amountCard}>
            <span className={styles.amountLabel}>
              Próxima factura estimada
            </span>
            <strong className={styles.amountValue}>
              {fmtMoneyCents(
                preview.next_invoice_total_cents,
                preview.currency
              )}
            </strong>
          </div>
        </div>

        {preview.expires_at && (
          <div className={styles.metaInfo}>
            Este cálculo es válido hasta:{" "}
            <strong>{fmtDate(preview.expires_at)}</strong>
          </div>
        )}

        {preview.effective_at && (
          <div className={styles.metaInfo}>
            El cambio se aplicará el:{" "}
            <strong>{fmtDate(preview.effective_at)}</strong>
          </div>
        )}

        {Array.isArray(preview.lines) && preview.lines.length > 0 && (
          <div className={styles.linesList}>
            {preview.lines.map((line) => (
              <div key={line.id} className={styles.lineItem}>
                <span>{line.description}</span>
                <strong>
                  {fmtMoneyCents(line.amount_cents, preview.currency)}
                </strong>
              </div>
            ))}
          </div>
        )}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            type="button"
            className={styles.primaryButton}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Confirmando..." : "Aceptar y cambiar plan"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanChangePreviewModal;
